import React, { useEffect, useState } from "react";
import cx from "classnames";
import { Link } from "gatsby";
import { Link as ScrollLink } from "react-scroll";
import { Collapse } from "@material-ui/core";
import { Image } from "src/components/image";
import { ProjectInfoModal } from "src/components/project/info-modal";
import { useSiteContext } from "src/context/siteContext";
import { useMediaQuery } from "@material-ui/core";

import { ReactComponent as SmallArrowLeft } from "src/images/svg/SmallArrowLeft.svg";
import { ReactComponent as AtAGlance } from "src/images/svg/AtAGlance.svg";
import { ReactComponent as X } from "src/images/svg/X.svg";
import { ReactComponent as SmallPlus } from "src/images/svg/SmallPlus.svg";

import * as styles from "./header.module.css";

interface GalleryItem {
	_key: string;
	type: string;
	copy?: any;
	image?: any;
}

interface ProjectHeaderProps {
	location: {
		state: {
			prevPath?: string;
		};
	};
	data: {
		title: string;
		gallery: [
			{
				items: GalleryItem[];
			}
		];
		detailsCopy?: any[];
		client?: string;
		whatWeDidTags?: {
			tags: any[];
		};
	};
}

export const ProjectHeader = ({ location, data }: ProjectHeaderProps) => {
	const { gallery, title, detailsCopy, client, whatWeDidTags } = data;
	const { headerIsVisible } = useSiteContext();
	const isMobile = useMediaQuery("(max-width:767px)");

	const [showAtAGlance, setShowAtAGlance] = useState(false);
	const [infoModalOpen, setInfoModalOpen] = useState(false);

	const toggleAtAGlance = () => {
		setShowAtAGlance(!showAtAGlance);
	};

	const toggleInfoModal = () => {
		setInfoModalOpen(!infoModalOpen);
	};

	const imageItems = gallery
		.map(
			(section) =>
				section.items &&
				section.items.map((item) => {
					if (item.image && item.image.asset?._ref) {
						return item;
					}
				})
		)
		.flat();

	const includeAtAGlance = gallery.length > 1;

	return (
		<div
			className={cx(styles.header, headerIsVisible ? styles.headerShift : "")}
		>
			<div className={styles.inner}>
				<div className={styles.row}>
					<Link
						className={styles.backLink}
						to={location?.state?.prevPath || `/work`}
					>
						<SmallArrowLeft className="mr025" />{" "}
						<span className="label">Back to projects</span>
					</Link>
					<div className={styles.buttons}>
						{detailsCopy && (
							<button
								className={cx("reset px05", styles.infoButton)}
								onClick={toggleInfoModal}
							>
								<span className="label">Info</span>
								<SmallPlus className="ml05"></SmallPlus>
							</button>
						)}
						{includeAtAGlance && !isMobile && (
							<button
								className={cx("reset px05 hide-small", styles.atAGlanceButton)}
								onClick={toggleAtAGlance}
							>
								{showAtAGlance ? (
									<>
										<span className="label">Close</span>
										<X className="ml05" />
									</>
								) : (
									<>
										<AtAGlance className="mr05" />
										<span className="label">At a glance</span>
									</>
								)}
							</button>
						)}
					</div>
				</div>
				{includeAtAGlance && !isMobile && (
					<Collapse in={showAtAGlance}>
						<div
							className={cx(
								"hide-scrollbar",
								styles.thumbnailNav,
								showAtAGlance ? styles.reveal : ""
							)}
						>
							{imageItems &&
								imageItems.map((item: any) => {
									if (!item?._key) {
										return null;
									}
									return (
										<ScrollLink
											key={item._key}
											className={styles.thumbnailLink}
											to={`${item._key}`}
											spy={true}
											smooth={true}
											offset={-200}
											duration={500}
											onClick={toggleAtAGlance}
										>
											{item.image?.asset?._ref && (
												<Image
													className={styles.thumbnail}
													alt={item.image.alt || title}
													gatsbyImageClassName={styles.thumbnailGatsbyImage}
													imageId={item.image.asset._ref}
												/>
											)}
										</ScrollLink>
									);
								})}
						</div>
					</Collapse>
				)}
			</div>
			{detailsCopy && (
				<ProjectInfoModal
					open={infoModalOpen}
					toggle={toggleInfoModal}
					data={{ client, whatWeDidTags, detailsCopy }}
				/>
			)}
		</div>
	);
};

// ProjectCard.whyDidYouRender = true;
